import React, { useEffect, useState } from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const initialValues = {
    title: ''
};

const validationSchema = Yup.object({
    title: Yup.string()
        .required('این فیلد الزامی است..')
        .min(2, "تعداد حروف کم است  ")
        .max(50, "تعداد حروف زیاد است "),
});
 
const Create = () => {
     const { addData } = useEntityCrud('Question/SetQuestion');

    const navigate = useNavigate();
    const { id } = useParams();

    const { readData: readDataOpinionFactor } = useEntityCrud('OpinionFactor/getAll')
    const [opinionFactorList, setOpinionFactorList] = useState([]);
    useEffect(() => {
        readDataOpinionFactor().then(res => {
            setOpinionFactorList(res.data.result.map(item => ({ value: item.id, label: item.title, isActive: item.status })))
        });
    }, [])


    const onSubmit = (values) => {
         
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        const postedData = {
            "title": values.title,
            "status": true,
            "factorId": values.factorId.value,
            "opinionId": id,
        };
        addData(postedData).then(({ data }) => {
             
            if (data.status) {
                toast.success('پرسش جدید با موفقیت ایجاد شد');
                return navigate(`/surveyQuestion/${id}`);
            }
            else
                toast.error(data.message);
        }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));

    }


    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });

  
    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">ایجاد پرسش جدید</div>
                <a className="backIconLink"  onClick={() => navigate(-1)}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <Form formik={formik}
                    opinionFactorList={opinionFactorList} setOpinionFactorList={setOpinionFactorList}
                    />
            </div>
        </div>
    );
}

export default Create;